var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { alpha } from '@mui/material/styles';
import { paginationItemClasses } from '@mui/material/PaginationItem';
// ----------------------------------------------------------------------
var COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
// ----------------------------------------------------------------------
export function pagination(theme) {
    var lightMode = theme.palette.mode === 'light';
    var rootStyles = function (ownerState) {
        var _a, _b;
        var defaultColor = ownerState.color === 'standard';
        var filledVariant = ownerState.variant === 'text';
        var outlinedVariant = ownerState.variant === 'outlined';
        var softVariant = ownerState.variant === 'soft';
        var defaultStyle = (_a = {},
            _a["& .".concat(paginationItemClasses.root)] = __assign(__assign({}, (outlinedVariant && {
                borderColor: alpha(theme.palette.grey[500], 0.24)
            })), (_b = {}, _b["&.".concat(paginationItemClasses.selected)] = __assign(__assign({ fontWeight: theme.typography.fontWeightSemiBold }, (outlinedVariant && {
                borderColor: 'currentColor'
            })), (defaultColor && __assign({ backgroundColor: alpha(theme.palette.grey[500], 0.08) }, (filledVariant && {
                color: lightMode ? theme.palette.common.white : theme.palette.grey[800],
                backgroundColor: theme.palette.text.primary,
                '&:hover': {
                    backgroundColor: lightMode ? theme.palette.grey[700] : theme.palette.grey[100]
                }
            })))), _b)),
            _a);
        var colorStyle = COLORS.map(function (color) {
            var _a, _b;
            return (__assign({}, (ownerState.color === color && (_a = {},
                _a["& .".concat(paginationItemClasses.root)] = (_b = {},
                    _b["&.".concat(paginationItemClasses.selected)] = __assign({}, (ownerState.color === color && __assign({}, (softVariant && {
                        color: theme.palette[color][lightMode ? 'dark' : 'light'],
                        backgroundColor: alpha(theme.palette[color].main, 0.08),
                        '&:hover': {
                            backgroundColor: alpha(theme.palette[color].main, 0.16)
                        }
                    })))),
                    _b),
                _a))));
        });
        return __spreadArray([defaultStyle], __read(colorStyle), false);
    };
    return {
        MuiPagination: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return rootStyles(ownerState);
                }
            }
        }
    };
}
